import 'babel-polyfill';
import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { StyleRoot } from 'radium';

import '@zanichelli/albe-web-components/www/build/web-components-library.css';
import { defineCustomElements } from '@zanichelli/albe-web-components/loader';

import Root from './containers/Root';
import store from './store';

setTimeout(() => {
    const element = document.getElementById('full-loader');
    element.parentNode.removeChild(element);

    defineCustomElements(window);

    ReactDOM.render(
        //resolve horizontal scroll error due to a bootstrap bug
        <div>
            <Provider store={store} style={{ minHeight: '100%', position: 'relative' }}>
                <StyleRoot>
                    <Root />
                </StyleRoot>
            </Provider>
        </div>,
        document.getElementById('root')
    );
}, 50);
